import React, { useState, useEffect } from "react";
import { graphql, useStaticQuery } from "gatsby";
import {
  BannerContainer,
  BannerBg,
  BannerImage,
  BannerIntro,
  BannerHeading,
  BannerSubtitle,
  CodeSpace,
  Heading,
} from "./style";
import Typewriter from "typewriter-effect";
import AOS from "aos";
import "aos/dist/aos.css"; // You can also use <link> for styles
// ..
const Banner = () => {
  const data = useStaticQuery(graphql`
    query {
      allFile(filter: { ext: { regex: "/png/" }, name: { in: ["banner1"] } }) {
        edges {
          node {
            childImageSharp {
              fluid {
                ...GatsbyImageSharpFluid
              }
              id
            }
          }
        }
      }
    }
  `);
  //   console.log(data);
  const [heading1, setHeading1] = useState(false);
  const [headingTitle, setHeadingTitle] = useState(false);
  useEffect(() => {
    AOS.init({
      duration: 600,
    });
    AOS.refresh();
  }, []);
  return (
    <>
      <BannerContainer>
        <BannerBg>
          <BannerImage
            fluid={data.allFile.edges[0].node.childImageSharp.fluid}
          />

          <BannerIntro>
            <div css={``}>
              <BannerHeading>
                {heading1 ? (
                  "Hi I'm"
                ) : (
                  <Typewriter
                    onInit={(typewriter) => {
                      typewriter
                        .typeString("Hi I'm")
                        .callFunction(() => {
                          setHeading1(true);
                        })
                        .start();
                    }}
                  />
                )}
                {heading1 && (
                  <Heading>
                    {headingTitle ? (
                      "Amit Chakraborty"
                    ) : (
                      <Typewriter
                        onInit={(typewriter) => {
                          typewriter
                            .typeString("Amit Chakraborty")
                            .callFunction(() => {
                              setHeadingTitle(true);
                            })
                            .start();
                        }}
                      />
                    )}
                  </Heading>
                )}
              </BannerHeading>
              {headingTitle && (
                <BannerSubtitle>
                  {`<code> `}{" "}
                  <CodeSpace>
                    <Typewriter
                      onInit={(typewriter) => {
                        typewriter.typeString("& I build.").start();
                      }}
                    />
                  </CodeSpace>{" "}
                  {` </code>`}
                </BannerSubtitle>
              )}
            </div>
          </BannerIntro>
        </BannerBg>
      </BannerContainer>
    </>
  );
};

export default Banner;
